//#region Libraries
//#endregion
//#region Styles
import { Container, Text } from "./styles";
//#endregion
//#region Components
import NavigateButton from "components/NavigateButton/NavigateButton";
//#endregion

const ReservationsPaginator = ({
    quantity,
    nextOrBackReservationPage
}) => {
    const { idx, total, thereIsMoreThan1, position } = quantity;
    const toBackOrNextReservationPage = (next = false) => {
        nextOrBackReservationPage(idx, next);
    }
    return (
        <Container>
            <NavigateButton 
                size="very-small" 
                angle="90deg"
                disabled={idx === 1 || (thereIsMoreThan1 && position === "last")}
                onClick={() => toBackOrNextReservationPage()}/>
            <Text>{idx} de {total} asesoría(s)</Text>
            <NavigateButton 
                size="very-small" 
                angle="270deg"
                disabled={idx === total || (thereIsMoreThan1 && position === "first")}
                onClick={() => toBackOrNextReservationPage(true)}/>
        </Container>
    );
}

export default ReservationsPaginator;